<template>
  <div>
    <StepModel
      :ui="uiBasePersonal"
      :name="STEP_NAMES.contactCodeVerification"
      ui-title="Contact Verification"
      ui-subtitle="Let’s verify the customer mobile number to make sure we can reach the customer"
     ui-hide-button
    >
      <FieldsetModel :ui="uiNoticeFieldset" :name="FIELDSET_NAMES.customerConsent">
        <p>
          <span id="firstSpan">{{this.displayText+this.isMobileNumber+this.displayTextEnd}}</span>
          <span id="secondSpan" />
          <button id="linkButton" @click.prevent="validateFn()">
            <a class="hyperlinkCss" href="#">{{this.linkText}}</a>
          </button>
          <span id="thirdSpan">{{this.endText}}</span>
        </p>

        <p hidden class="saving" id="spinner">
          <span class="dot"></span>
          <span class="dotText">Give us few seconds...</span>
        </p>
      </FieldsetModel>

      <FieldsetModel :ui="uiBaseFieldset" :name="FIELDSET_NAMES.resendOTP">
        <p class="resendText">
          {{this.resendLinkText1}}
          <button id="resendButton" @click="resendVerificationLink">
            <a
              style="text-decoration:underline;font-weight: bold;"
              href="#"
            >{{this.resendButtonText}}</a>
          </button>
          <span>{{this.resendLinkText2}}</span>
        </p>
      </FieldsetModel>
      <FieldsetModel :ui="uiBaseFieldset" :name="FIELDSET_NAMES.resendOTPProgressBar">
        <p hidden class="saving" id="spinnerResend">
          <span class="dot"></span>
          <span class="dotText">Give us few seconds...</span>
        </p>
      </FieldsetModel>
    </StepModel>
  </div>
</template>
      <script>
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import otpServiceReferal from "@/forms/api/services/otp-referral";
//import STEP_NAMES from "@/forms/constants/step-names";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import flowManager from "@/lib/services/flow-manager";
import store from "@/store";
import FIELD_NAMES from "@/forms/constants/field-names";
import {
  SET_PRODUCT_TYPE,
  SET_CUSTOMER_CONSENT,
} from "@/lib/constants/mutations";
import sleep from "@/forms/helpers/sleep";

export default {
  name: "ContactVerification",
  mixins: [FormComponentMixin],
  props: {
    validateFn: Function,
  },
  components: {
    MainForm,
    StepModel,
    FieldsetModel,
  },
  data: () => ({
    displayText: "We have sent a link to the customer on mobile number(",
    displayTextEnd:
      "). Please wait for the customer to confirm the application. Click ",
    linkText: "here",
    endText: " to proceed.",
    secondaryButtonText: "",
    customerMobile: "",
    resendLinkText1: "Please click on",
    resendLinkText2: " link in case customer has not recieved the message.",
    resendButtonText: "Resend",
  }),
 
  computed: {
    isMobileNumber() {
      return this.fieldValues(FIELD_NAMES.phoneNumber);
    },
  },
  methods: {
    async resendVerificationLink() {
      const spinner = document.getElementById("spinnerResend");
      var currentStep = this.STEP_NAMES.contactCodeVerification;
      spinner.removeAttribute("hidden");
      const response = await otpServiceReferal.sendOtpCustomer(
        currentStep,
        this
      );
      if (!response || !!response) {
        spinner.setAttribute("hidden", "");
      }

      spinner.setAttribute("hidden", "");
    },
  },
};
</script>
<style scoped>
#linkButton {
  background-color: transparent;
  border: none;
}
#linkButton > a {
  position: relative;
  color: #000000;
  text-decoration: underline;
  color: #551a8b;
  font-weight: bold;
}

#linkButton > a:hover {
  color: #551a8b;
}
#linkButton > a:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  bottom: 0;
  right: 0;
  background-color: #551a8b;
  visibility: hidden;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transition: all 0.3s ease-in-out 0s;
  transition: all 0.3s ease-in-out 0s;
}
#linkButton > a:hover:before {
  visibility: visible;
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}
@media (max-width: 768px) {
  [class="hyperlinkCss"] {
    font-size: 15px;
    text-decoration: underline;
    color: #551a8b;
    font-weight: bold;
  }
}
@keyframes fadein {
  0% {
    opacity: 0;
  }
  66% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes fadein {
  0% {
    opacity: 0;
  }
  66% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}
@keyframes blink {
  /**
     * At the start of the animation the dot
     * has an opacity of .2
     */
  0% {
    opacity: 0.2;
  }
  /**
     * At 20% the dot is fully visible and
     * then fades out slowly
     */
  20% {
    opacity: 1;
  }
  /**
     * Until it reaches an opacity of .2 and
     * the animation can start again
     */
  100% {
    opacity: 0.2;
  }
}

.saving .dotAnimation {
  /**
     * Use the blink animation, which is defined above
     */
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
  /**
     * This makes sure that the starting style (opacity: .2)
     * of the animation is applied before the animation starts.
     * Otherwise we would see a short flash or would have
     * to set the default styling of the dots to the same
     * as the animation. Same applies for the ending styles.
     */

  animation-fill-mode: both;
}

.dot {
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
  height: 8px;
  width: 8px;
  background-color: #000000;
  border-radius: 50%;
  display: inline-block;
  margin-right: 15px;
}
.dotText {
  font-family: "Moderat", serif;
  font-weight: 300;
  font-size: 15px;
  color: #9e9e9e;
}
.resendText {
  color: #9e9e9e;
}
</style>